import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrokenHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrokenHeart"><Path d="M12 14.9999L13 11.9999L10 8.99993L10.0019 8.99529C10.4892 7.78429 11.1218 6.33794 12 5.37552C18.5042 -1.25346 29.6544 11.0575 12 21C-5.51019 11.1388 5.31545 -1.05248 11.8397 5.21684" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBrokenHeart;
